module.exports = __webpack_public_path__ + "static/media/3.29cb65b0.jpg";